// export const SERVER_URL = "http://192.168.1.134:3003";
// export const SERVER_URL = "http://localhost:5003";
// export const SERVER_URL = "http://172.104.173.134:3003";
// export const SERVER_URL = "https://imsgsmopaapi.secretdemo.com";
// export const SERVER_URL = "inventoryapi.secretdemo.com";
export const SERVER_URL = "https://inventoryapi.secretdemo.com";

// export const SERVER_URL = "http://localhost:3003";

